/**
 * @generated SignedSource<<c44e5f74b3a1895b10e6801bc1f72678>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type twoSectionTopWidgetHomeV2Queue$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
    readonly " $fragmentSpreads": FragmentRefs<"homeSecondaryV2ContentItemContent" | "leadSectionTopHomeV2Content">;
  };
  readonly " $fragmentType": "twoSectionTopWidgetHomeV2Queue";
}>;
export type twoSectionTopWidgetHomeV2Queue$key = ReadonlyArray<{
  readonly " $data"?: twoSectionTopWidgetHomeV2Queue$data;
  readonly " $fragmentSpreads": FragmentRefs<"twoSectionTopWidgetHomeV2Queue">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "twoSectionTopWidgetHomeV2Queue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeSecondaryV2ContentItemContent"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "leadSectionTopHomeV2Content"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "89662702a198621a42a61bedbe6418f1";

export default node;
